import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import { Link } from 'react-router-dom';
import { useLogout } from "../hooks/auth";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import { useCustomerPortal } from "../hooks/payment";
import EmailIcon from '@mui/icons-material/Email';
import ContactModal from './ContactFormModal';
import Settings from '@mui/icons-material/Settings';

export default function AccountMenu() {
  const { logout } = useLogout();
  const { goToBillingPortal } = useCustomerPortal();
  const subscription = JSON.parse(localStorage.getItem("subscription"));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openContactModal, setOpenContactModal] = React.useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenContactModal = () => {
    setOpenContactModal(true);
    handleClose();
  };

  const handleCloseContactModal = () => {
    setOpenContactModal(false);
  };

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <Avatar
            onClick={handleClick}
            sx={{ ml: 2, width: 32, height: 32, cursor: 'pointer' }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          ></Avatar>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem component={Link} to="/account" onClick={handleClose}>
          <Avatar /> My Account
        </MenuItem>
        <Divider />

        <MenuItem component={Link} to="/settings" onClick={handleClose}>
        <ListItemIcon>
        <Settings fontSize="small" />
        </ListItemIcon>
        Settings
        </MenuItem>


        <MenuItem onClick={goToBillingPortal}>
        <ListItemIcon>
        <CardMembershipIcon fontSize="small" />
        </ListItemIcon>
        Billing
        </MenuItem>



    <MenuItem onClick={handleOpenContactModal}>
      <ListItemIcon>
        <EmailIcon fontSize="small" />
      </ListItemIcon>
      Contact Us
    </MenuItem>
    <Divider />
    <MenuItem onClick={logout}>
      <ListItemIcon>
        <CardMembershipIcon fontSize="small" />
      </ListItemIcon>
      Logout
    </MenuItem>
  </Menu>
  {openContactModal && <ContactModal open={openContactModal} handleClose={handleCloseContactModal} />}
</React.Fragment>
);
}